module.exports = __webpack_public_path__ + "images/logo-yellow@2x_f7fc3b1f672a87e48cdb9ce47624403e.png";